<template>
  <div class="container-sm" v-if="!isInvalidNumberOptions && !isEmptyOptions">
    <ol class="options">
      <li v-for="(option, index) in options" :key="index">
        {{ getOption(option) }}
      </li>
    </ol>
  </div>
</template>

<script>
import { every, isNumber } from 'lodash';

export default {
  name: 'quiz-otions',

  props: {
    options: {
      type: Array,
    },
  },

  computed: {
    isInvalidNumberOptions() {
      return every(this.options, (item) => {
        const option = Number(this.getOption(item));
        return !isNaN(option)
            && isNumber(option)
            && this.getOption(item).length === 1;
      });
    },

    isEmptyOptions() {
      return every(this.options, answer => !answer.content);
    },
  },

  methods: {
    getOption(option) {
      return option.content || option.value;
    },
  },
};
</script>

<style lang="scss">
  @import '../assets/styles/components/_typographies';
  @import '../assets/styles/components/_breakpoints';

  .options > li {
    font-size: 17px;
    font-weight: 400;

    @media (min-width: $desktop-breakpoint) {
      font-size: 20px;
    }
  }
</style>
